import { useCallback, useEffect } from 'react';
import { useMobilePreviewStore } from '@/Domain/store/mobilePreview.store';
import NewWidget from '@/UI/Website/NewWidget/NewWidget';
import {
  CHAT_PAGE_ACCESS_TOKEN_KEY,
  getCurrentScenarioId,
  getPreviewIdentityToken,
} from '@/context';

// Full-screen mobile widget from the TopBar "Preview" button; embed view renders its own close (quickchat_minimize).
export const MobilePreviewDialog = () => {
  const { open, retainedScenarioId, closePreview, handoffToSupport } = useMobilePreviewStore();
  const scenarioId = getCurrentScenarioId();
  const token = getPreviewIdentityToken();
  const customParams = token ? { [CHAT_PAGE_ACCESS_TOKEN_KEY]: token } : undefined;

  const handleSupportOpened = useCallback(() => {
    handoffToSupport(scenarioId);
  }, [handoffToSupport, scenarioId]);

  useEffect(
    () => () => {
      if (useMobilePreviewStore.getState().retainedScenarioId === scenarioId) closePreview();
    },
    [closePreview, scenarioId],
  );

  if (!open && retainedScenarioId !== scenarioId) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-background"
      hidden={!open}
      data-testid="mobile-preview-dialog"
    >
      <NewWidget
        showViewModeToggle={false}
        fixedViewType="embed"
        source="preview"
        className="h-full"
        customParams={customParams}
        showCloseButton
        onMinimize={closePreview}
        bindContextIframe={false}
        detectSupportIntent={open}
        onSupportOpened={handleSupportOpened}
      />
    </div>
  );
};
